/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ContactSubmission, ApplyForLicensingStorePayload, LicensingApplication, OrganizationSubmission, ProjectSubmission,
} from '../models';
import { SubmissionSource, RequestStatus } from '../models/enums';

const buildCreatePayload = (payload: ApplyForLicensingStorePayload): LicensingApplication => {
  const company: OrganizationSubmission = {
    name: payload.companyName,
    addressLine1: payload.companyAddressLine1,
    addressLine2: payload.companyAddressLine2,
    city: payload.companyCompanyCity,
    state: payload.companyCompanyState,
    zip: payload.companyCompanyZip,
    country: payload.companyCountry,
    email: payload.companyEmail,
    phone: payload.companyPhone,
    fax: payload.companyFax,
    businessType: payload.businessType,
    source: SubmissionSource.LicensingApplication,
  };

  const primaryContact: ContactSubmission = {
    firstName: payload.primaryContactFirstName,
    lastName: payload.primaryContactLastName,
    organizationName: payload.companyName,
    jobTitle: payload.primaryContactTitle,
    email: payload.primaryContactEmail,
    phone: payload.contactPhone,
    fax: payload.contactFax,
    memberType: 'QCP',
    source: SubmissionSource.LicensingApplication,
  };

  const principal1Contact: ContactSubmission = {
    firstName: payload.companyPrincipalFirstName,
    lastName: payload.companyPrincipalLastName,
    jobTitle: payload.companyPrincipalTitle,
    email: payload.companyPrincipalEmail,
    memberType: 'QCP',
    source: SubmissionSource.LicensingApplication,
  };

  const principal2Contact: ContactSubmission = {
    firstName: payload.secondCompanyPrincipalFirstName,
    lastName: payload.secondCompanyPrincipalLastName,
    jobTitle: payload.secondCompanyPrincipalTitle,
    email: payload.secondCompanyPrincipalEmail,
    memberType: 'QCP',
    source: SubmissionSource.LicensingApplication,
  };

  const project1: ProjectSubmission = {
    name: payload.projectOneName,
    city: payload.projectOneCity,
    stateProvince: payload.projectOneState,
    yearCompleted: Number.parseInt(payload.projectOneYearCompleted, 10),
    summary: payload.projectOneProjectSummary,
    source: SubmissionSource.LicensingApplication,
  };

  const project2: ProjectSubmission = {
    name: payload.projectTwoName,
    city: payload.projectTwoCity,
    stateProvince: payload.projectTwoState,
    yearCompleted: Number.parseInt(payload.projectTwoYearCompleted, 10),
    summary: payload.projectTwoProjectSummary,
    source: SubmissionSource.LicensingApplication,
  };

  const project3: ProjectSubmission = {
    name: payload.projectThreeName,
    city: payload.projectThreeCity,
    stateProvince: payload.projectThreeState,
    yearCompleted: Number.parseInt(payload.projectThreeYearCompleted, 10),
    summary: payload.projectThreeProjectSummary,
    source: SubmissionSource.LicensingApplication,
  };

  return {
    company,
    revisedCompany: company,

    primaryContact,
    revisedPrimaryContact: primaryContact,

    principal1Contact,
    revisedPrincipal1Contact: principal1Contact,

    principal2Contact,
    revisedPrincipal2Contact: principal2Contact,

    companyActivelySeeksAndConductsBusienss: payload.conductsWithGeneralPublic,
    revisedCompanyActivelySeeksAndConductsBusienss: payload.conductsWithGeneralPublic,

    yearsInBusiness: Number.parseInt(payload.yearsInBusiness, 10),
    numberOfEmployees: Number.parseInt(payload.numberOfEmployees, 10),
    numberOfEmployeesInOffice: Number.parseInt(payload.numberOfEmployeesInOffice, 10),
    numberOfInstallers: Number.parseInt(payload.numberInstallers, 10),
    totalSquareFootage: Number.parseInt(payload.totalSquareFootage, 10),
    revisedYearsInBusiness: Number.parseInt(payload.yearsInBusiness, 10),
    revisedNumberOfEmployees: Number.parseInt(payload.numberOfEmployees, 10),
    revisedNumberOfEmployeesInOffice: Number.parseInt(payload.numberOfEmployeesInOffice, 10),
    revisedNumberOfInstallers: Number.parseInt(payload.numberInstallers, 10),
    revisedTotalSquareFootage: Number.parseInt(payload.totalSquareFootage, 10),

    ownOrLeaseFacility: payload.ownLeaseFacility,
    ownOrLeaseEquipment: payload.ownLeaseEquipment,
    annualGrossSales: Number.parseFloat(payload.annualGrossSales),
    lineOfBusiness: JSON.stringify(payload.lineOfBusiness),
    businessSummary: payload.businessSummary,
    revisedOwnOrLeaseEquipment: payload.ownLeaseEquipment,
    revisedOwnOrLeaseFacility: payload.ownLeaseFacility,
    revisedAnnualGrossSales: Number.parseFloat(payload.annualGrossSales),
    revisedLineOfBusiness: JSON.stringify(payload.lineOfBusiness),
    revisedBusinessSummary: payload.businessSummary,

    standards: JSON.stringify(payload.awiStandards),
    howDidYouHearAboutQCP: payload.hearAboutQpc === 'Other' ? payload.hearAboutQpcOther : payload.hearAboutQpc,
    licenseType: payload.licensingType,
    qualityGrade: payload.quailityGrade,
    licensingSections: JSON.stringify(payload.licensingSections),
    revisedStandards: JSON.stringify(payload.awiStandards),
    revisedHowDidYouHearAboutQCP: payload.hearAboutQpc === 'Other' ? payload.hearAboutQpcOther : payload.hearAboutQpc,
    revisedLicenseType: payload.licensingType,
    revisedQualityGrade: payload.quailityGrade,
    revisedLicensingSections: JSON.stringify(payload.licensingSections),

    project1,
    revisedProject1: project1,

    project2,
    revisedProject2: project2,

    project3,
    revisedProject3: project3,

    recentlyBidAProjectRequiringQCP: payload.recentlyBidAProjectRequiringQCP,
    revisedRecentlyBidAProjectRequiringQCP: payload.recentlyBidAProjectRequiringQCP,
    haveBeenAwardedContractRequiringQCP: payload.haveBeenAwardedContractRequiringQCP,
    revisedHaveBeenAwardedContractRequiringQCP: payload.haveBeenAwardedContractRequiringQCP,
    joinReason: payload.joinReason,
    revisedJoinReason: payload.joinReason,
    awiStatus: payload.awiStatus,
    revisedAwiStatus: payload.awiStatus,

    status: RequestStatus.Pending,
  };
};


export default {
  buildCreatePayload,
};